export default "__VITE_ASSET__DEI9VGpw__"